"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Happy;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Happy(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Emojis",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#231f20;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "icon"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "happy"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-2",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M50,92.5A42.5,42.5,0,1,1,92.5,50,42.548,42.548,0,0,1,50,92.5Zm0-80A37.5,37.5,0,1,0,87.5,50,37.542,37.542,0,0,0,50,12.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M50,71.561A24.649,24.649,0,0,1,25.379,46.939a2.5,2.5,0,0,1,2.5-2.5H72.121a2.5,2.5,0,0,1,2.5,2.5A24.649,24.649,0,0,1,50,71.561ZM30.538,49.439a19.622,19.622,0,0,0,38.924,0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M44.321,38.314a2.5,2.5,0,0,1-2.5-2.5,5.747,5.747,0,0,0-11.494,0,2.5,2.5,0,0,1-5,0,10.747,10.747,0,0,1,21.494,0A2.5,2.5,0,0,1,44.321,38.314Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M72.121,38.314a2.5,2.5,0,0,1-2.5-2.5,5.747,5.747,0,0,0-11.494,0,2.5,2.5,0,0,1-5,0,10.747,10.747,0,0,1,21.494,0A2.5,2.5,0,0,1,72.121,38.314Z"
  }))));
}